const ApprovalStatus = {
  Enabled: "ENABLED",
  Pending: "PENDING",
};

export default Object.freeze(ApprovalStatus);
